import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnRejectReview(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos rejeitar a versão.'
            break
        case '2xx':
            message = 'Excluímos a versão do eitri-app.'
            break
        case 400:
            message = 'Para rejeitar uma versão do eitri-app é necessário justificar.'
            break
        case 401:
            message =
                'Ops! O seu tempo de acesso expirou, para rejeitar a versão do eitri-app é necessário realizar o login.'
            break
        case 403:
            message = 'Permissão Negada.'
            break
        case 500:
        default:
            message =
                'Ops! Algo estranho ocorreu e não removemos a versão do eitri-app. Por favor, tente novamente mais tarde.'
    }
    return message
}
